import React from 'react';
import { Link } from 'react-router-dom';

const PageCTA = ({ label, title, to, className = '' }) => (
  <div className={['scroll-fade', className].filter(Boolean).join(' ')}>
    <Link to={to} className="cta-link">
      <span className="overline">{label}</span>
      <span className="cta-title">
        {title}
        <span className="arrow">›</span>
      </span>
    </Link>
  </div>
);

export default PageCTA;
